import { ProductAlertModal } from '@gripp/shared-ui';
import { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { ProductAlertButton } from './productAlertButton';

type MainProps = {
  productIds: string[];
};

export const ProductsSelectionPanelMain = ({ productIds }: MainProps) => {
  const [showAlertModal, setShowAlertModal] = useState(false);

  // Alerts are defined per product, so only enable the action on a single
  // selection. With multiple selections the panel is empty for now.
  const canCreateAlert = productIds.length === 1;
  const productId = productIds[0];

  // Close the modal if the selection grows/shrinks to anything other than
  // exactly one product, so a previously-opened modal doesn't stay bound to
  // a stale productId.
  useEffect(() => {
    if (!canCreateAlert && showAlertModal) {
      setShowAlertModal(false);
    }
  }, [canCreateAlert, showAlertModal]);

  return (
    <View style={styles.container}>
      {canCreateAlert && (
        <ProductAlertButton onPress={() => setShowAlertModal(true)} />
      )}
      {showAlertModal && canCreateAlert && (
        <ProductAlertModal
          visible={showAlertModal}
          onClose={() => setShowAlertModal(false)}
          productId={productId}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 16,
    gap: 12,
  },
});
